import { BaseService, Service } from "/@/cool";
@Service("dealer")
class Dealer extends BaseService {
	constructor() {
		super();

		let prefix = "";
		if (this.namespace) {
			prefix = this.namespace.replace(/\//g, ":") + ":";
		}

		this.permission["add"] = prefix + "add";
		this.permission["update"] = prefix + "update";
		this.permission["info"] = prefix + "info";
		this.permission["list"] = prefix + "list";
		this.permission["page"] = prefix + "page";
		this.permission["delete"] = prefix + "delete";
		this.permission["export"] = prefix + "export";
		this.permission["first"] = prefix + "first";
		this.permission["second"] = prefix + "second";
		this.permission["allLevel"] = prefix + "allLevel";
		this.permission["userInfo"] = prefix + "userInfo";
		this.permission["dealerAll"] = prefix + "dealerAll";
		this.permission["bindList"] = prefix + "bindList";
	}

	first(params: any) {
		return this.request({
			url: "/first",
			method: "GET",
			params
		});
	}

	second(params: any) {
		return this.request({
			url: "/second",
			method: "GET",
			params
		});
	}
	dealerShop(params: any) {
		return this.request({
			url: "/dealerShop",
			method: "POST",
			data: { ...params }
		});
	}
	dealerAll(params: any) {
		return this.request({
			url: "/dealerAll",
			method: "POST",
			data: { ...params }
		});
	}
	allLevel(params: any) {
		return this.request({
			url: "/allLevel",
			method: "POST",
			data: { ...params }
		});
	}
	userInfo(params: any) {
		return this.request({
			url: "/userInfo",
			method: "POST",
			data: { ...params }
		});
	}

	// 只查询一层
	bindList(params: any) {
		return this.request({
			url: "/bindList",
			method: "POST",
			data: { ...params }
		});
	}
}
export default Dealer;
